export function initTabs() {
  addChangeTabClickListener();
  addTabChangeListener();
}


/**
 * add listener for tab changes
 */
function addTabChangeListener() {
  const noGallerySelector = '.js-noGallery';
  const dontScrollClass = 'js-dontScroll';
  const hideClass = 'hide';
  const generalHeaderSelector = '.js-generalHeader';
  const $generalHeader = $(generalHeaderSelector);

  $(noGallerySelector).on('show.bs.tab', () => {
    $generalHeader.addClass(hideClass);
  });

  $(document).on('shown.bs.tab', 'a[data-toggle="tab"]:not(.js-noGallery)', (event) => {
    $generalHeader.removeClass(hideClass);
    const windowHeight = $(window).height();
    if ((windowHeight && windowHeight <= 700) && !$(event.currentTarget).hasClass(dontScrollClass)) {
      const idToScrollTo = $(event.currentTarget).attr('href');
      if (idToScrollTo) {
        scrollToElementWithId(idToScrollTo);
      }
    }
  });
}

/**
 * add listener to links which change tabs
 */
function addChangeTabClickListener() {
  const tabChangeTabLinkSelector = '.js-changeTab';
  const $changeTabLink = $(tabChangeTabLinkSelector);
  $changeTabLink.on('click', (event) => {
    $('a[href="' + $(event.currentTarget).attr('href') + '"]').tab('show');
  });
}

/**
 * scrollToElementWithId
 */
function scrollToElementWithId(elemId: string) {
  const offset = $(elemId).offset();
  if (offset) {
    const position = offset.top - 160;
    $('html, body').animate({scrollTop: position}, 600);
  }
}
